import { render } from "./menuAdmin.vue?vue&type=template&id=3ce766b5&scoped=true"
import script from "./menuAdmin.vue?vue&type=script&lang=js"
export * from "./menuAdmin.vue?vue&type=script&lang=js"

import "./menuAdmin.vue?vue&type=style&index=0&id=3ce766b5&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce766b5"]])

export default __exports__